class Component extends HTMLElement {
    show() {
        this.hidden = false;
    }

    hide() {
        this.hidden = true;
    }

    /**
     * @param {string} type
     * @param {any} detail
     */
    dispatch(type, detail = null) {
        const setup = {bubbles: true, cancelable: true};
        const event = new CustomEvent(type, {detail, ...setup});
        return this.dispatchEvent(event);
    }
}

export default Component;
